import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { IJwtPayload, UserRole } from '@talent-week/shared-types';

/**
 * 认证状态接口
 */
interface AuthState {
  /** JWT Token */
  token: string | null;
  /** 当前登录用户信息 */
  user: LoginUser | null;
  /** 是否正在加载 */
  loading: boolean;
  /** 登录 */
  login: (token: string, user: LoginUser) => void;
  /** 登出 */
  logout: () => void;
  /** 设置加载状态 */
  setLoading: (loading: boolean) => void;
  /** 更新用户信息 */
  updateUser: (user: Partial<LoginUser>) => void;
}

/**
 * 登录用户信息
 */
export interface LoginUser {
  id: string;
  username: string;
  name: string;
  role: UserRole;
  managedDistrict?: string;
  managedUnitId?: string;
}

/**
 * 认证状态 Store
 *
 * 使用 zustand + persist 持久化到 localStorage，
 * 实现页面刷新后保持登录状态。
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      loading: false,

      login: (token, user) => {
        set({ token, user, loading: false });
      },

      logout: () => {
        set({ token: null, user: null, loading: false });
      },

      setLoading: (loading) => {
        set({ loading });
      },

      updateUser: (userData) => {
        set((state) => ({
          user: state.user ? { ...state.user, ...userData } : null,
        }));
      },
    }),
    {
      name: 'talent-week-auth',
      // 只持久化 token 和 user
      partialize: (state) => ({
        token: state.token,
        user: state.user,
      }),
    },
  ),
);
